import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFound = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 410,
	height: 177,
	viewBox: "0 0 410 177",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M159.874 43.4395C159.874 43.4395 141.741 26.2002 123.591 25.8455L136.756 34.8279L112.216 30.1674L134.983 41.6494L108.302 43.4395C122.601 46.0036 135.222 52.6155 145.655 64.6136L159.874 43.4395Z",
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .6,
			d: "M158.358 51.4367C158.358 51.4367 150.721 38.468 141.168 36.4878L147.111 43.597L134.649 38.192L145.385 47.8658L131.055 46.47C138.324 49.5052 144.251 55.04 148.405 63.8536L158.358 51.4205V51.4367Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.772 174.931V145.403H0V130.761L80.9414 7.27939H98.2511V126.856H122.631V145.403H98.2511V174.931H77.772ZM23.8923 127.344H78.5034V42.1763L23.8923 127.344Z",
			fill: "#EDEEF3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.37 176.395C187.679 176.395 172.482 168.911 160.78 153.944C149.24 138.814 143.47 117.908 143.47 91.2272C143.47 65.8476 149.078 45.2674 160.292 29.4865C171.507 13.7056 186.866 5.81519 206.37 5.81519C225.062 5.81519 240.177 13.3803 251.717 28.5104C263.419 43.4778 269.271 64.3834 269.271 91.2272C269.271 116.607 263.663 137.187 252.449 152.968C241.396 168.586 226.037 176.395 206.37 176.395ZM206.37 157.361C219.536 157.361 229.775 151.422 237.089 139.546C244.566 127.67 248.304 111.563 248.304 91.2272C248.304 70.2403 244.484 53.9713 236.845 42.4203C229.206 30.7067 219.048 24.8499 206.37 24.8499C193.205 24.8499 182.884 30.8694 175.408 42.9084C168.094 54.7847 164.437 70.891 164.437 91.2272C164.437 112.051 168.256 128.32 175.895 140.034C183.697 151.585 193.855 157.361 206.37 157.361Z",
			fill: "#EDEEF3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M365.141 174.931V145.403H287.369V130.761L368.31 7.27939H385.62V126.856H410V145.403H385.62V174.931H365.141ZM311.261 127.344H365.872V42.1763L311.261 127.344Z",
			fill: "#EDEEF3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.591 144.771L204.822 136.083L189.829 132.83C185.061 131.795 180.253 131.186 175.414 130.97L204.157 156.557C207.398 159.443 212.389 159.153 215.266 155.914C216.717 154.28 217.356 152.21 217.23 150.21C217.108 148.192 216.226 146.227 214.608 144.775L214.591 144.771Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M148.56 84.7962L208.631 138.246L189.449 134.313C184.681 133.278 179.873 132.669 175.034 132.453C172.016 132.304 168.982 132.35 165.951 132.525C152.514 133.367 139.25 129.355 128.535 121.215L121.172 115.609L121.003 115.491L148.565 84.7791L148.56 84.7962Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M146.912 86.3186C145.217 84.8091 138.04 90.1126 130.88 98.1731C123.721 106.234 119.298 114.003 121.011 115.517C122.706 117.027 129.883 111.723 137.043 103.663C144.202 95.6024 148.625 87.8326 146.912 86.3186Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M251.161 107.518L241.388 98.8251L236.403 84.2861C234.819 79.6731 233.646 74.9512 232.876 70.1544L261.631 95.7359C264.873 98.6231 265.172 103.622 262.294 106.862C260.842 108.497 258.863 109.372 256.869 109.478C254.853 109.596 252.805 108.94 251.165 107.501L251.161 107.518Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M210.186 15.8203L210.328 15.9667L216.696 22.5869C225.949 32.22 231.432 44.846 232.152 58.2273C232.312 61.2372 232.633 64.2538 233.132 67.2095C233.894 71.9719 235.058 76.6428 236.621 81.2392L242.724 99.7114L183.199 46.65L210.199 15.8417L210.186 15.8203Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M183.852 47.0986C182.221 45.5453 186.716 37.2761 193.88 28.6393C201.062 20.007 208.203 14.2758 209.833 15.8291C211.463 17.3824 206.969 25.6517 199.805 34.2885C192.623 42.9208 185.482 48.6519 183.852 47.0986Z",
			fill: "#3085E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M274.922 148.788L259.363 166.308L272.824 168.076C276.27 168.539 279.118 165.344 278.269 161.946L274.927 148.771L274.922 148.788Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M252.731 108.83L182.587 46.3946L147.055 86.4428L217.199 148.878C227.174 157.752 239.557 163.513 252.756 165.43L259.421 166.314L274.976 148.798L273.317 142.27C269.891 129.349 262.702 117.72 252.726 108.847L252.731 108.83Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M202.697 115.828C184.854 99.9557 175.15 78.3651 173.844 56.2632L147.055 86.4507L217.179 148.877C227.166 157.771 239.531 163.528 252.734 165.427L259.403 166.294L274.958 148.78L273.316 142.257C272.834 140.434 272.287 138.648 271.642 136.891C247.573 140.147 222.272 133.273 202.697 115.828Z",
			fill: "#D9DEEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.463 83.6992L180.246 48.9776L176.771 45.8828C175.679 44.9099 174.001 44.9953 173.021 46.1017L145.753 76.8585C144.784 77.9518 144.872 79.6329 145.977 80.6176L149.452 83.7124L149.463 83.6992Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M171.741 47.7082L170.99 47.0342C168.014 44.3813 163.675 44.2631 160.6 46.5237C160.13 46.8541 159.693 47.2662 159.303 47.7089L145.835 62.8921C145.445 63.3348 145.08 63.8207 144.817 64.3338C142.935 67.6599 143.563 71.9648 146.539 74.6178L147.289 75.2919L171.758 47.7127L171.741 47.7082Z",
			fill: "#002347"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M231.417 106.285C225.676 101.17 216.895 101.685 211.796 107.427C206.696 113.168 207.224 121.963 212.965 127.078C218.706 132.193 227.488 131.678 232.587 125.936C237.686 120.194 237.159 111.4 231.417 106.285Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M235.1 104.106C242.038 110.406 242.616 121.306 236.38 128.462",
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M203.499 83.1541L186.639 102.172C185.466 103.496 183.442 103.614 182.119 102.436L180.053 100.596C178.73 99.4177 178.61 97.3894 179.783 96.0656L196.644 77.0474C197.817 75.7235 199.841 75.6054 201.164 76.7836L203.23 78.6238C204.552 79.802 204.673 81.8303 203.499 83.1541Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M265.1 114.497C268.789 118.682 270.985 122.469 273.532 127.95C276.08 133.431 276.98 136.072 278.034 141.154",
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M126.345 113.579C128.931 111.867 133.454 108.143 137.727 103.807C142.1 99.3698 143.44 97.326 146.517 91.7429",
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M189.35 44.6693C191.935 42.9574 196.981 39.6938 200.732 34.8972C204.358 30.2608 206.842 26.9207 209.171 21.1382",
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M160.41 153.944C172.104 168.911 187.29 176.395 205.967 176.395V157.36C193.461 157.36 183.31 151.585 175.515 140.034C167.881 128.32 164.065 112.051 164.065 91.227C164.065 70.8908 167.719 54.7846 175.027 42.9082L159.923 29.4863C148.717 45.2672 143.113 65.8475 143.113 91.227C143.113 117.908 148.879 138.814 160.41 153.944Z",
			fill: "#EDEEF3"
		})
	]
});
const ForwardRef = forwardRef(SvgNotFound);
export default ForwardRef;
